import React, { useState } from "react";
import { Dropdown, Input, Nav, Navbar } from "rsuite";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import * as userManager from '../../Services/UserSessionManager';
import { Link, useNavigate } from "react-router-dom";
import { ProfileDropDown } from "./ProfileDropDown";
import './Home.css';

export const AppAdmin = () => {

    const [checkRole,setCheckRole]=useState(userManager.GetUserRole());
    const [navBar,setNavBar]=useState([])
    const handleChange=(event:any)=>{
    setNavBar( event.target.innerText);
 
}

    return(
        <>
         {checkRole=='H'||checkRole=='A'?
          <Dropdown title={"Admin"}
            className="nav-bar-text-white"
           icon={<BootstrapIcon cssClasses="p-2 nav-bar-text-white" bootStrapIconName="key-fill" size={18} />}>
                <Link className="link-simple" to={'/FileUpload'}>
                <Dropdown.Item
                        icon={<BootstrapIcon bootStrapIconName={"file-earmark-arrow-up-fill"} size={14} cssClasses={'pe-2'} />}
                    >
                        Upload
                    </Dropdown.Item>
                    </Link>
                    {checkRole=='A'?
                    <div>
                    <Link className="link-simple" to={'/Accounts'}>
                    <Dropdown.Item
                        icon={<BootstrapIcon bootStrapIconName={"bank2"} size={14} cssClasses={'pe-2'} />}
                    >
                        Account Master
                    </Dropdown.Item>
                </Link>
                <Link className="link-simple" to={'/ProcessMaster'}>
                    <Dropdown.Item
                        icon={<BootstrapIcon bootStrapIconName={"bank2"} size={14} cssClasses={'pe-2'} />}
                    >
                        KRA Process Master
                    </Dropdown.Item>
                </Link>
                <Link className="link-simple" to={'/SubStateMaster'}>
                    <Dropdown.Item
                        icon={<BootstrapIcon bootStrapIconName={"bank2"} size={14} cssClasses={'pe-2'} />}
                    >
                        KRA SubState Master
                    </Dropdown.Item>
                </Link>
                <Link className="link-simple" to={'/WeightageMaster'}>
                    <Dropdown.Item
                        icon={<BootstrapIcon bootStrapIconName={"bank2"} size={14} cssClasses={'pe-2'} />}
                    >
                        KRA Productivity Target Master
                    </Dropdown.Item>
                </Link>
                </div>:<></>}
                 </Dropdown>:<></>}
        </>
     )
 

}
